<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Nro</th>
              <th scope="col" class="text-center" style="max-width: 250px">
                Evento
              </th>
              <th scope="col" class="text-center">Creado por</th>
              <th scope="col" class="text-center">Modalidad</th>
              <th scope="col" class="text-center">Dirigido a</th>
              <th scope="col" class="text-center">Fecha</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="paginatedItems.length > 0">
              <tr v-for="(item, index) in paginatedItems" :key="item.id">
                <!-- <th scope="row">{{ item.id }}</th> -->
                <th scope="row" class="text-center">
                  {{ (currentPage - 1) * itemsPerPage + index + 1 }}
                </th>
                <td class="text-center">{{ item.title }}</td>
                <td class="text-center">
                  {{ item.user }} <br />
                  {{ item.unity }}
                </td>
                <td class="text-center">{{ item.modality }}</td>
                <td class="text-center">
                  {{ getOrientedNames(item.orienteds_json) }}
                </td>
                <td class="text-center" v-if="item.init_date !== item.end_date">
                  {{ formatDate(item.init_date) }} al
                  {{ formatDate(item.end_date) }}
                </td>
                <td class="text-center" v-else>
                  {{ formatDate(item.init_date) }}
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="text-center py-4 text-muted">
                <EmptyState
                  title="No se encontraron eventos activos."
                  :size="450"
                  fontSize="fs-5"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="props.list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import Pagination from "@/pages/components/Pagination.vue";
import EmptyState from "@/components/emptyState.vue";

const props = defineProps({ list: Array });

const sortedList = computed(() => {
  return [...props.list].sort((a, b) => b.id - a.id);
});

let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  //return props.list.slice(startIndex, endIndex);
  return sortedList.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}

function getOrientedNames(jsonStr) {
  try {
    const parsed = JSON.parse(jsonStr);
    if (!parsed.orienteds || !Array.isArray(parsed.orienteds)) return "";
    return parsed.orienteds.map((o) => o.name).join(", ");
  } catch (e) {
    //console.warn("json inválido", jsonStr);
    return "";
  }
}

function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date)) return "-";
  return date.toLocaleDateString("es-BO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
</script>
